"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOldPassword = exports.validateConfirmPassword = exports.validatePassword = exports.validateOtp = exports.isValidOtp = exports.isValidPassword = exports.isValidDateOfBirth = exports.isValidEmail = exports.checkPasswordCriteria = void 0;
const regex_1 = require("./regex");
const checkPasswordCriteria = (password) => {
    return {
        uppercase: regex_1.passwordRegex.uppercase.test(password),
        lowercase: regex_1.passwordRegex.lowercase.test(password),
        number: regex_1.passwordRegex.number.test(password),
        special: regex_1.passwordRegex.special.test(password),
        length: regex_1.passwordRegex.length.test(password),
        noSpaces: !regex_1.passwordRegex.noSpaces.test(password), // Negate noSpaces regex
    };
};
exports.checkPasswordCriteria = checkPasswordCriteria;
const isValidEmail = (email) => {
    return regex_1.Regex.email.test(email);
};
exports.isValidEmail = isValidEmail;
const isValidDateOfBirth = (date) => {
    const dateInMillis = date.valueOf();
    const now = new Date().getTime();
    return now - dateInMillis > 0;
};
exports.isValidDateOfBirth = isValidDateOfBirth;
const isValidPassword = (password) => {
    return regex_1.passwordRegex.all.test(password);
};
exports.isValidPassword = isValidPassword;
const isValidOtp = (otp) => {
    return regex_1.Regex.otp.test(otp);
};
exports.isValidOtp = isValidOtp;
const validateOtp = (otp) => {
    if (!otp) {
        return "codeError";
    }
    else if (!(0, exports.isValidOtp)(otp)) {
        return "invalidCodeError";
    }
    else {
        return "";
    }
};
exports.validateOtp = validateOtp;
const validatePassword = (password) => {
    if (!password) {
        return "newPasswordError";
    }
    else if (!(0, exports.isValidPassword)(password)) {
        return "passwordCriteriaError";
    }
    else
        return "";
};
exports.validatePassword = validatePassword;
const validateConfirmPassword = (password, confirmPassword) => {
    if (!confirmPassword) {
        return "confirmPasswordError";
    }
    else if (password !== confirmPassword) {
        return "confirmPasswordMatchError";
    }
    else
        return "";
};
exports.validateConfirmPassword = validateConfirmPassword;
const validateOldPassword = (oldPassword) => {
    if (!oldPassword) {
        return "oldPasswordError";
    }
    else if (!regex_1.passwordRegex.length.test(oldPassword)) {
        return "oldPasswordCriteriaError";
    }
    else
        return "";
};
exports.validateOldPassword = validateOldPassword;
